import { render, staticRenderFns } from "./NewFactsheetOptionForm.vue?vue&type=template&id=307cea86&scoped=true&"
import script from "./NewFactsheetOptionForm.vue?vue&type=script&lang=js&"
export * from "./NewFactsheetOptionForm.vue?vue&type=script&lang=js&"
import style0 from "./NewFactsheetOptionForm.vue?vue&type=style&index=0&id=307cea86&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "307cea86",
  null
  
)

export default component.exports